import { useAppSelector } from '../../../base';
import { toolsSelectors } from '../../../actions';
import ChatMessage from './ChatMessage';

const ChatHistoryViewer = () => {
    const activeChatMessages = useAppSelector(
        toolsSelectors.getActiveChatMessages
    );
    const activeChatHistoryLoading = useAppSelector(
        toolsSelectors.getActiveChatHistoryLoading
    );

    return (
        <>
            {activeChatHistoryLoading ? (
                <div>Loading...</div>
            ) : (
                <>
                    {activeChatMessages.map((message) => (
                        <ChatMessage
                            key={message.id}
                            message={message}
                            messageId={String(message.id)}
                            isLastMessage={
                                message.id ===
                                activeChatMessages[
                                    activeChatMessages.length - 1
                                ].id
                            }
                        />
                    ))}
                </>
            )}
        </>
    );
};

export default ChatHistoryViewer;
